// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Y4vR","list":"BalanceDue_list__1r6Kp","listRow":"BalanceDue_listRow__2Ahmz","total":"BalanceDue_total__2HQAD"};